import React, { useState, useEffect } from "react";
import Tab from './Tab'
import TabCard from './TabCard';

const tabOptions = {
  'ARTICLE SUBMISSION': [
        {
      title: 'Choosing the Right Journal: Where Should I Submit?',
      blurb: 'Submitting your manuscript to the right journal is a crucial step in ensuring your work reaches the right audience and gains the recognition it deserves. Your choice of journal affects your article’s visibility, credibility, and overall impact in your field. Here are some key factors to consider when making your decision.',
      imgSrc: 'https://public.cureus.com/authors-hub/where-to-submit-header.png',
      path: "/authors_hub/where_to_submit"
    },
        {
      title: 'Medical Research Writing Resources & Tips for First-Time Authors',
      blurb: 'Writing your first article can seem like a daunting task, but it doesn’t need to be. We’ve gathered tips for everything from structuring your manuscript to refining your writing, ensuring that your work is impactful, clear, and aligned with journal requirements.',
      imgSrc: 'https://public.cureus.com/authors-hub/medical-writing-tips-header.png',
      path: "/authors_hub/medical_writing_tips"
    },
    {
      title: 'Avoiding Common Mistakes: Ensuring a Smooth Publication Process',
      blurb: 'Submitting an article manuscript for the first time can be both exciting and intimidating. There are several common mistakes that you should be aware of and learn to avoid. Here we highlight some of the challenges of publishing academic articles and offer practical advice to ensure a smooth experience when submitting your article.',
      imgSrc: 'https://public.cureus.com/authors-hub/common-mistakes-header.png',
      path: "/authors_hub/common_mistakes"
    }
  ],
  'REVIEW & REVISIONS': [
        {
      title: 'Handling Rejections, Deferrals & Resubmissions',
      blurb: 'Rejections and resubmissions are a normal part of the academic publishing journey. In order to successfully handle a rejection or prepare for resubmission you’ll need to be prepared, stay positive, be receptive to feedback, and show a willingness to refine your manuscript accordingly.',
      imgSrc: 'https://public.cureus.com/authors-hub/handling-deferrals-header.png',
      path: "/authors_hub/handling_deferrals"
    },
    {
      title: 'Navigating Peer Review: Responding to Reviewer Feedback with Confidence',
      blurb: 'Reviewer feedback might seem intimidating, but understanding the process and how to respond effectively can make a significant difference in getting your article published. Learn more about the different types of peer review, what reviewers evaluate, and how to use practical strategies to constructively and professionally respond to critiques.',
      imgSrc: 'https://public.cureus.com/authors-hub/peer-review-header.png',
      path: "/authors_hub/peer_review"
    }
  ],
  'AFTER PUBLICATION': [
        {
      title: 'Maximizing the Impact of Your First Published Research Article',
      blurb: 'Publishing your first article is a major milestone in your academic career, but your journey doesn’t end here. To make the most of your hard work, you need to actively promote your research, engage with your academic community, and track its impact.',
      imgSrc: 'https://public.cureus.com/authors-hub/maximizing-impact-header.png',
      path: "/authors_hub/maximizing_impact"
    },
    {
      title: 'Understanding Article Metrics: Tracking Reach and Impact',
      blurb: 'Article metrics provide valuable insights into how widely your article is read, shared, and cited, helping you measure its real-world impact. Learn more about key article metrics, what they mean, and how to track them effectively.',
      imgSrc: 'https://public.cureus.com/authors-hub/article-metrics-header.png',
      path: "/authors_hub/article_metrics"
    }
  ],
}

const tabSlugs = {
  'ARTICLE SUBMISSION': 'article_submission',
  'REVIEW & REVISIONS': 'review_revisions',
  'AFTER PUBLICATION': 'after_publication',
};

const slugToTab = Object.fromEntries(Object.entries(tabSlugs).map(([k, v]) => [v, k]));

const TabsSection = ({}) => {
  const [activeTab, setActiveTab] = useState("ARTICLE SUBMISSION")

  useEffect(() => {
    const slug = window.location.hash.replace('#', '');
    if (slugToTab[slug]) {
      setActiveTab(slugToTab[slug]);
    }
  }, []);  

  useEffect(() => {
    $(document).foundation({
      equalizer : {
        // Specify if Equalizer should make elements equal height once they become stacked.
        equalize_on_stack: true,
        // Allow equalizer to resize hidden elements
        act_on_hidden_el: false,
      }
    });
  }, [activeTab]);

  return (
    <>
      <div className="hub-tabs-container row">
        {Object.keys(tabOptions).map((tabTitle, index) => (
            <Tab
              key={tabTitle}
              title={tabTitle}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              index={index}
            />
        ))}    
      </div>
      <div className="tab-contents-container row" data-equalizer='tab-cards'>
          {tabOptions[activeTab].map((tabObject, index) => (
              <TabCard 
                key={tabObject.title}
                title={tabObject.title}
                blurb={tabObject.blurb}
                imgSrc={tabObject.imgSrc}
                path={tabObject.path}
                numCards={tabOptions[activeTab].length}
                index={index}
              />
          ))}  
      </div>
    </>
  )
}

export default TabsSection;
